<template>
  <LoginLayout>
    <jet-authentication-card>
      <div class="flex justify-around relative mr-10 ml-10 mt-5">
        <h3 class="text-gray-900 text-l font-medium mt-1">
          Login as Attendee
          <img class="absolute right-0 top-0" src="/image/icons/users-icon.svg" alt="users-icon" />
        </h3>
      </div>

      <div class="mb-4 text-sm text-gray-600 px-6 mt-4">
        Forgot your password? No problem. Just let us know your email address and we will email you
        a password reset link that will allow you to choose a new one.
      </div>

      <div v-if="status" class="mt-4 px-6 font-medium text-sm text-green-600">
        {{ status }}
      </div>

      <jet-validation-errors class="my-4 px-6" />

      <form @submit.prevent="submit" class="p-6">
        <div>
          <jet-label for="email" value="Email" />
          <jet-input
            id="email"
            type="email"
            class="mt-1 block w-full"
            v-model="form.email"
            required
            autofocus
            autocomplete="on"
          />
        </div>

        <div class="flex items-center justify-end mt-4">
          <jet-button
            :class="{ 'opacity-25': form.processing }"
            :disabled="form.processing"
            style="color: #3730a3; background: #e0e7ff; letter-spacing: 0; text-transform: none"
          >
            Email Password Reset Link
          </jet-button>
        </div>
      </form>
    </jet-authentication-card>
  </LoginLayout>
</template>

<script>
import JetAuthenticationCard from '@/Jetstream/AuthenticationCard.vue';
import JetButton from '@/Jetstream/Button.vue';
import JetInput from '@/Jetstream/Input.vue';
import JetLabel from '@/Jetstream/Label.vue';
import JetValidationErrors from '@/Jetstream/ValidationErrors.vue';
import LoginLayout from '../../Layouts/LoginLayout.vue';

export default {
  components: {
    JetAuthenticationCard,
    JetButton,
    JetInput,
    JetLabel,
    JetValidationErrors,
    LoginLayout,
  },

  props: {
    status: String,
  },

  data() {
    return {
      form: this.$inertia.form({
        email: '',
      }),
    };
  },

  methods: {
    submit() {
      this.form.post(this.route('password.email'));
    },
  },
};
</script>
